var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-form-group',{attrs:{"label":"Pays"}},[_c('b-form-select',{attrs:{"options":_vm.options,"value":_vm.pays},on:{"change":v => _vm.$emit('change', v)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }